import { ValueOfKey } from '../../utils-types';

export const SCAN_SOURCE_TYPE = {
  MANUAL: 'MANUAL',
  INBODY: 'INBODY',
} as const;

export type ScanSourceType = ValueOfKey<typeof SCAN_SOURCE_TYPE>;
